module.exports = __webpack_public_path__ + "img/graphics-5.133ec555.svg";